import React from 'react';
import "./rectangle-for-status.scss"

 function StatusBox({text, color, borderColor}) {
       return (
           <div className="status" style={{color, borderColor}}>
               <div className={"text"}>{text}</div>
           </div>
       )
 }
export default StatusBox;